// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer-footer-2Piyv_0","android":"footer-android-3NEbt_0","ios":"footer-ios-2hv59_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[name]-[local]-[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47c9c0e4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/others/footer.vue
// module id = Gc/j
// module chunks = 1